// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vK01","colBig":"styles_colBig__zWZnZ","colSmall":"styles_colSmall__hLOPa"};